import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "message-tip"
};
import { computed } from '../../../../adapter-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-tip',
  props: {
    content: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    var props = __props;
    var tipContent = computed(() => {
      var _props$content, _props$content2;
      return ((_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.text) || ((_props$content2 = props.content) === null || _props$content2 === void 0 ? void 0 : _props$content2.custom) || '';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(_unref(tipContent)), 1)]);
    };
  }
});